module.exports = __webpack_public_path__ + "img/olympic-medal.e5746a1c.jpg";